(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.edit')
    .controller('RolsMainEditCtrl', RolsMainEditCtrl);

  function RolsMainEditCtrl($scope,rolData,$translate,$state,$window, $rootScope,$stateParams,RolFactory,Notification,llistaentitats,llistaproductes) {
    var vm = this;
     var vm = this;
    vm.ctrlName = 'RolsMainEditCtrl';
    vm.rol=rolData.data;
    vm.isNew =angular.isUndefined(vm.rol);

    if (angular.isUndefined(vm.rol)) {
        vm.rol = {entitat:[],producte:[]};
        if (!$rootScope.issuperadmin){
          if (llistaentitats.data.list.length>0){
            vm.rol.entitat.push(llistaentitats.data.list[0]);
          }
        }
    }

    vm.listallentitat=llistaentitats.data.list;
    //filtre dels productes segons les entitats seleccionades
    if (llistaproductes.data.list!=null )
    {
      vm.listallproductesentitat= llistaproductes.data.list.filter(createFilterFor());
    }
    else
    {
      vm.listallproductesentitat=[]; 
    }
    

     function createFilterFor() {
          return function filterFn(item) {
            if (item.identitat === null){
              //seguretat per exemple te entitat null
              return true;
            }
            else if(vm.rol.entitat!=null){
              if (vm.rol.entitat.length>0){
                if (item.identitat === vm.rol.entitat[0].id){
                  return true;
                }
              }
            }
            return false;
            };
        }

    vm.onChangeFunction = onChangeFunction;
    function onChangeFunction(){
      vm.formulari.camps[2].list=llistaproductes.data.list.filter(createFilterFor());
     //si hi ha menys entitats de les originals haurem d'eliminar de la llista de rols ja 
      //seleccionats el rols que de les entitats eliminades
      if (vm.rol.entitat.length===0)
      {
        if(vm.rol.producte.length>0){
          vm.rol.producte.splice(0,1);
        }
      }
    }  

    vm.idRol = $stateParams.idRol;
    vm.errors = [];
    
    //functions
    vm.back = back;
    if (angular.isUndefined(vm.rol.acls)) {
      vm.readonlylistentitat=!$rootScope.issuperadmin;
      vm.readonlylistproductes=false;
    }
    else
    {
      vm.readonlylistentitat=!$rootScope.issuperadmin || vm.rol.acls.length>0;
      vm.readonlylistproductes=vm.rol.acls.length>0;
    }


    //long vars
    vm.formulari = {
      nom: 'formulariRol',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: true,
              columns: 9,
              maxLength: 50
            },
             {
              type: 'chips',
              name: 'entitat',
              list:vm.listallentitat,
              onChange :  onChangeFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
              createNew: true,
              columns: 12,
              readonly:vm.readonlylistentitat ||  !vm.isNew,
              label:"CERCA_ENTITATS",
              mdMinLenght:0,
              mdMaxChips:2,
              required:true
            },
            {
              type: 'chips',
              name: 'producte',
              list:vm.listallproductesentitat,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIROL_CERCA'),
              createNew: false,
              columns: 12,
              readonly:vm.readonlylistproductes || !vm.isNew,
              label:"CERCA_PRODUCTES",
              mdMinLenght:0,
              mdMaxChips:2,
              required:true
            },
            {
              type: 'checkbox',
              name: 'eliminar',
              label: 'ROL_ES_POT_ELIMINAR',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            },
            {
              type: 'checkbox',
              name: 'inicial',
              label: 'ROL_INICIAL',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            },
            {
              type: 'checkbox',
              name: 'visibleall',
              label: 'ROL_VISIBLEALL',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            }          
      ]
    };


    function func() {
      if (vm.isNew) {
        createNew();
      }
      else {
        edit();
      }
    }

    function createNew() {
      RolFactory.add(vm.rol).then(function (response) {
        vm.rol.id = response.data;
        $rootScope.$broadcast('rols.main.llista.add', vm.rol);
        HelperFactory.setParams($stateParams, {'idRol': response.data});
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function edit() {
      RolFactory.update(vm.idRol, vm.rol).then(function (response){
      $rootScope.$broadcast('rols.main.llista.update', vm.rol);
      $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }



    function back() {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
      }
      else {
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }
    }

    function notificarregistre() {
      RolFactory.avisregistre(vm.idRol).then(function (response){


      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    
    function notificarconfirmar() {
      RolFactory.avisconfirmar(vm.idRol).then(function (response){


      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }


    if (vm.isNew) {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': true});
    }

  }
}());
